// extracted by mini-css-extract-plugin
export default {"container":"MainMenu_container__1KaWp","menuButton":"MainMenu_menuButton__1743s","title":"MainMenu_title__1G4-A"};